module.exports = {
  init: () => {
    $("#forgot-form").submit(function () {
      $("#forgot-result").text("");
      var mail = $("#forgot-mail").val();

      if (mail == "") {
        $("#forgot-result").text("E-mail skal angives.");
        return false;
      }

      var promise = $.post("/umbraco/surface/User/ResetPassword", {
        email: mail,
      });

      promise.done(function (e) {
        if (e.error) {
          $("#forgot-result").text(e.error);
        } else {
          window.location = window.location.href;
        }
      });

      return false;
    });

    $("#login-form").submit(function () {
      $("#login-result").text("");
      var mail = $("#login-mail").val();
      var password = $("#login-password").val();

      if (mail == "" || password == "") {
        $("#login-result").text("E-mail og adgangskode skal angives.");
        return false;
      }

      var promise = $.post("/umbraco/surface/User/Authenticate", {
        email: mail,
        password: password,
      });

      promise.done(function (e) {
        console.log("her!", e);
        if (e.error) {
          $("#login-result").text(e.error);
        } else {
          window.location = window.location.href;
        }
      });

      return false;
    });

    $(".login-form").submit(function () {
      const form = $(this)
      form.find(".login-result").text("");
      var mail = form.find(".login-mail").val();
      var password = form.find(".login-password").val();

      if (mail == "" || password == "") {
        form.find(".login-result").text("Please write an e-mail and password.");
        return false;
      }

      var promise = $.post("/umbraco/surface/User/Authenticate", {
        email: mail,
        password: password,
      });

      promise.done(function (e) {
        if (e.error) {
          form.find(".login-result").text(e.error);
        } else {
          window.location = window.location.href;
        }
      });

      return false;
    });

    $("#create-form").submit(function () {
      $("#create-result").text("");
      var mail = $("#create-mail").val();
      var phone = $("#create-phone").val();

      if (mail == "" || phone == "") {
        $("#create-result").text("E-mail og telefon skal angives.");
        return false;
      }

      var promise = $.post("/umbraco/surface/User/Create", {
        email: mail,
        phoneNumber: phone,
      });

      promise.done(function (e) {
        if (e.error) {
          $("#create-result").text(e.error);
        } else {
          window.location = window.location.href;
        }
      });

      return false;
    });

    $("#create-form-wholesale").submit(function () {
      $("#create-result").text("");
      var mail = $("#create-mail").val();
      var phone = $("#create-phone").val();
      var vat = $("#create-vat").val();
      var company = $("#create-company").val()
      var password = $("#create-password").val()

      if (mail == "" || phone == "" || vat == "" || company == "" || password == "") {
        $("#create-result").text("Please fill all required fields.");
        return false;
      }

      var promise = $.post("/umbraco/surface/User/CreateWholesale", {
        email: mail,
        phoneNumber: phone,
        vat: vat,
        company: company,
        password: password
      });

      promise.done(function (e) {
        if (e.error) {
          $("#create-result").text(e.error);
        } else {
          window.location = window.location.href;
        }
      });

      return false;
    });

    $("#update-form-wholesale").submit(function () {
      $("#update-result").text("");
      var mail = $("#update-mail").val();
      var phone = $("#update-phone").val();
      var vat = $("#update-vat").val();
      var company = $("#update-company").val()

      if (mail == "" || phone == "" || vat == "" || company == "") {
        $("#update-result").text("Please fill all required fields.");
        return false;
      }

      var promise = $.post("/umbraco/surface/User/Update", {
        email: mail,
        phoneNumber: phone,
        vat: vat,
        company: company
      });

      promise.done(function (e) {
        if (e.error) {
          $("#update-result").text(e.error);
        } else {
          window.location = window.location.href;
        }
      });

      return false;
    });

    $(".remove-favorite").click(function () {
      const element = $(this);
      const vehicleId = element.data("id");
      $.post("/umbraco/surface/User/RemoveFavorite", { vehicleId: vehicleId }, function () {
        //window.location = window.location.href;
        element.parent().find(".remove-favorite").hide();
        element.parent().find(".add-favorite").show();
      });
      return false;
    });

    $(".add-favorite").click(function () {
      if ($("body").hasClass("authenticated")) {
        const element = $(this);
        const vehicleId = element.data("id");
        $.post("/umbraco/surface/User/AddFavorite", { vehicleId: vehicleId }, function () {
          // window.location = window.location.href;
          element.parent().find(".remove-favorite").show();
          element.parent().find(".add-favorite").hide();
        });
      } else {
        $(".header-bar-tool").click();
      }
      return false;
    });

    $("#testDrive-form").submit(function () {
      $("#testDrive-result").text("");
      var date = $("#testDrive-date").val();
      var time = $("#testDrive-time").val();
      var name = $("#testDrive-name").val();
      var mail = $("#testDrive-email").val();
      var city = $("#testDrive-city").val();
      var zip = $("#testDrive-zip").val();
      var address = $("#testDrive-address").val();
      var phone = $("#testDrive-phonenumber").val();
      var car = $("#testDrive-id").val();
      var carurl = $("#testDrive-carurl").val();
      var location = $("#testDrive-location").val();

      if ($("#testDrive-address").length) {
        if (date == "" || name == "" || phone == "" || city == "" || zip == "" || address == "") {
          $("#testDrive-result").text("Dato, navn, telefon, by, postnummer og adresse skal angives.");
          return false;
        }
      } else {
        if (date == "" || name == "" || phone == "") {
          $("#testDrive-result").text("Dato, navn og telefon skal angives.");
          return false;
        }
      }

      var promise = $.post("/umbraco/surface/Contact/TestDrive/", {
        name: name,
        phone: phone,
        mail: mail,
        city: city,
        zip: zip,
        address: address,
        time: time,
        date: date,
        car: car,
        carurl: carurl,
        location: location,
      });

      promise.done(function () {
        $("#testDrive-date, #testDrive-time, #testDrive-name, #testDrive-email, #testDrive-phonenumber").val("");
        $("#testDrive-result").css({ "font-weight": "bold" }).text("Tak for din henvendelse. Vi vil besvare den inden for 24 timer.");
      });
      return false;
    });

    $("#finance-form").submit(function () {
      $("#finance-result").text("");
      var name = $("#finance-name").val();
      var mail = $("#finance-mail").val();
      var phone = $("#finance-phone").val();
      var comments = $("#finance-comments").val();
      var car = $("#finance-id").val();
      var carurl = $("#finance-carurl").val();
      var months = $("#finance-months").val();

      if (mail == "" || name == "" || phone == "") {
        $("#finance-result").text("Navn, e-mail og telefon skal angives.");
        return false;
      }

      var promise = $.post("/umbraco/surface/Contact/Finance/", {
        name: name,
        phone: phone,
        mail: mail,
        car: car,
        carurl: carurl,
        comments: comments,
        months: months,
      });

      promise.done(function () {
        $("#finance-name, #finance-mail, #finance-phone, #finance-comments").val("");
        $("#finance-result").css({ "font-weight": "bold" }).text("Tak for din henvendelse. Vi vil besvare den inden for 24 timer.");
      });
      return false;
    });

    $("#leasing-form").submit(function () {
      $("#leasing-result").text("");
      var name = $("#leasing-name").val();
      var mail = $("#leasing-mail").val();
      var phone = $("#leasing-phone").val();
      var milagesuggestion = $("#leasing-milagesuggestion").val();
      var comments = $("#leasing-comments").val();
      var car = $("#leasing-id").val();
      var carurl = $("#leasing-carurl").val();
      var months = $("input.leasing-months-display").val();
      var km = $("input.leasing-km-display").val();
      var leasingType = $("input.leasing-type").val();

      if (mail == "" || name == "" || phone == "") {
        $("#leasing-result").text("Navn, e-mail og telefon skal angives.");
        return false;
      }

      var promise = $.post("/umbraco/surface/Contact/Leasing/", {
        name: name,
        phone: phone,
        mail: mail,
        car: car,
        carurl: carurl,
        comments: comments,
        months: months,
        km: km,
        leasingType: leasingType,
        milagesuggestion: milagesuggestion,
      });

      promise.done(function () {
        $("#leasing-name, #leasing-mail, #leasing-phone, #leasing-comments, #leasing-milagesuggestion").val("");
        $("#leasing-result").css({ "font-weight": "bold" }).text("Tak for din henvendelse. Vi vil besvare den inden for 24 timer.");
      });
      return false;
    });
  },
};
